import React from "react";

import {
  FaFacebook,
  FaInstagram,
  FaYoutube,
  FaUser,
  FaLinkedin,
} from "react-icons/fa";
import { FaXTwitter } from "react-icons/fa6";

import { Link } from "react-router-dom";
import logo from "../assets/img/logo.svg";
import { useSelector } from "react-redux";

const Header = () => {
  const { currentUser } = useSelector((state) => state.user);

  return (
    <>
      <nav className="navbar navbar-expand-lg sticky-top navbar-bg">
        <div className="container-fluid">
          <Link className="navbar-brand" to="/">
            <img src={logo} className="logo" alt="logo" />
          </Link>
          <button
            className="navbar-toggler"
            type="button"
            data-bs-toggle="collapse"
            data-bs-target="#navbarNav"
            aria-controls="navbarNav"
            aria-expanded="false"
            aria-label="Toggle navigation"
          >
            <span className="navbar-toggler-icon">
              <i className="fas fa-bars"></i>
            </span>
          </button>
          <div className="collapse navbar-collapse" id="navbarNav">
            <ul className="navbar-nav ms-auto mb-lg-0">
              <li className="nav-item">
                <Link
                  className="nav-link follow-us-txt"
                  aria-current="page"
                  href="#"
                >
                  Follow Us
                </Link>
              </li>
              <li className="nav-item">
                <Link
                  className="nav-link"
                  to="https://www.facebook.com/share/1EmUDddP4Q/?mibextid=LQQJ4d"
                  target="_blank"
                >
                  <FaFacebook className="social-icon" />
                </Link>
              </li>
              <li className="nav-item">
                <Link
                  className="nav-link"
                  to="https://www.instagram.com/regnum_group/?igsh=MWhvODlmbTBqcWQ2MQ%3D%3D#"
                  target="_blank"
                >
                  <FaInstagram className="social-icon" />
                </Link>
              </li>
              <li className="nav-item">
                <Link
                  className="nav-link"
                  to="https://www.youtube.com/@homesdekho-pvt-ltd"
                  target="_blank"
                >
                  <FaYoutube className="social-icon" />
                </Link>
              </li>
              <li className="nav-item">
                <Link
                  className="nav-link"
                  to="https://www.linkedin.com/company/regnumgroup/"
                  target="_blank"
                >
                  <FaLinkedin className="social-icon" />
                </Link>
              </li>
              <li className="nav-item">
                <Link
                  className="nav-link"
                  to="https://x.com/homesdekho28?s=11"
                  target="_blank"
                >
                  <FaXTwitter className="social-icon" />
                </Link>
              </li>

              {currentUser ? (
                <li className="nav-item">
                  <Link className="nav-link" to="/profile">
                    <FaUser />
                  </Link>
                </li>
              ) : (
                <></>
              )}
            </ul>
          </div>
        </div>
      </nav>
    </>
  );
};

export default Header;
